import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import createDecorator from 'final-form-focus';
import { FinancialInstitutionType, YesNoAnswer } from '../generated-types';
export const focusOnErrors = createDecorator();
export const requiredField = value => value ? '' : 'Påkrevet felt';
export const optional = () => {
  return '';
};
export const requiredFieldWithCustomError = (value, customError) => value ? '' : customError;
export const minLengthValidator = value => value.length >= 10 ? '' : 'Minst 10 tegn kreves';
export const maxLengthValidator = (value, maxLength, shouldSkipValidation) => {
  return shouldSkipValidation || value.length < maxLength ? '' : "Feltet kan maksimalt inneholde ".concat(maxLength, " tegn");
};
export const configurableMinLengthValidator = (value, minimumOfCharacters) => value.length >= minimumOfCharacters ? '' : "Svaret m\xE5 inneholde minst ".concat(minimumOfCharacters, " tegn");
export const decimalFormatToDecimal = value => typeof value === 'string' ? Number(value.replace(/,/, '.')) : value;
export const positiveNumbersOnly = value => /^\d+([,.]\d+)?$/.test(value) && decimalFormatToDecimal(value) >= 0 ? '' : 'Kun positive tall tillatt';
export const maxValueOfNumber = (value, maxValue, errorText) => {
  return Number(value) <= maxValue ? '' : errorText !== null && errorText !== void 0 ? errorText : "Kan ikke v\xE6re mer enn ".concat(maxValue);
};
export const globalIntermediaryIdentificationNumber = value => {
  const pattern = new RegExp('^[0-9A-Z]{6}\\.[0-9A-Z]{5}\\.[A-Z]{2}\\.\\d{3}$');
  return pattern.test(value) ? '' : 'Skriv inn på gyldig GIIN format ("XXXXXX.XXXXX.BB.TTT", hvor X er en bokstav A-Z eller et tall 0-9, B er en bokstav A-Z og T er et tall 0-9.)';
};
const VALID_GIIN_TYPE_VALUES = Object.values(FinancialInstitutionType);
export const validType = value => {
  const institutionType = value.split('.')[2];
  return VALID_GIIN_TYPE_VALUES.includes(institutionType) ? '' : "Skriv inn p\xE5 gyldig GIIN format (\"XXXXXX.XXXXX.BB.TTT\", paret 'BB' m\xE5 v\xE6re en av ".concat(VALID_GIIN_TYPE_VALUES, ")");
};
export const validateCountry = (value, countries) => {
  const countryNumericCode = Number(value.split('.')[3]);
  return countries.countries.find(country => country.numericCode === countryNumericCode) ? '' : "Skriv inn p\xE5 gyldig GIIN format (\"XXXXXX.XXXXX.BB.TTT\", hvor 'TTT' er ISO landsnummer. ".concat(countryNumericCode, " er ugyldig ISO landsnummer)");
};
const CHOOSE_AT_LEAST_ONE_OPTION_TEXT = 'Vennligst velg minst ett alternativ';
export const requiresAtLeastOneCheckboxSelected = values => {
  if (!values) return CHOOSE_AT_LEAST_ONE_OPTION_TEXT;
  if (!values.listAnswers || values.listAnswers.length < 1) return CHOOSE_AT_LEAST_ONE_OPTION_TEXT;
  return '';
};
export const requiresAtLeastOneBeneficialOwnerCheckboxSelected = values => {
  if (!values) return CHOOSE_AT_LEAST_ONE_OPTION_TEXT;
  const atLeastOneSelected = Object.keys(values).find(key => values[key] === true);
  if (!atLeastOneSelected) return CHOOSE_AT_LEAST_ONE_OPTION_TEXT;
  return '';
};
export const valueNotAllowed = (value, disallowedValue, disallowedText) => value !== disallowedValue ? '' : "'".concat(disallowedText, "' er ikke et gyldig valg");
export const yesNoNoValidator = (mainYes, firstNo, secondNo) => {
  return mainYes === YesNoAnswer.YES && firstNo === YesNoAnswer.NO && secondNo === YesNoAnswer.NO ? 'Dette ser ikke riktig ut, er du sikker på at det stemmer?' : '';
};
export const isValidFnr = fnr => {
  if (!fnr || fnr.length !== 11) {
    return false;
  }
  const generateControlNumber = (fnr, factors) => {
    const checksum = factors.map((factor, i) => parseInt(fnr.charAt(i), 10) * factor).reduce((acc, value) => acc + value, 0);
    const k = 11 - checksum % 11;
    return k === 11 ? 0 : k;
  };
  const k1 = generateControlNumber(fnr, [3, 7, 6, 1, 8, 9, 4, 5, 2]);
  const k2 = generateControlNumber(fnr, [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]);
  return k1 === parseInt(fnr.charAt(9), 10) && k2 === parseInt(fnr.charAt(10), 10);
};
export const isValidSSN = value => {
  return isValidFnr(value) ? '' : 'Ikke gyldig Fødselsnummer / D-nummer';
};
export const isValidSSNFactory = isFromServer => isFromServer ? () => '' : isValidSSN;
export const isValidTINLength = value => {
  return value.length <= 35 ? '' : 'Skattenummeret kan maksimalt inneholde 35 tegn';
};
export const isCountrySwedenAndValidSwedishTIN = (value, whatCountryIsTheTaxRelation) => {
  const pattern = new RegExp('^\\d{6}[+-]\\d{4}$');
  return whatCountryIsTheTaxRelation === 'SWE' && !pattern.test(value) ? 'Skriv inn gyldig skattenummer på formatet: "TTTTTT-TTTT" eller "TTTTTT+TTTT" hvor T er tall 0-9' : '';
};
export const composeValidators = function () {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }
  return value => validators.reduce((error, validator) => error || validator(value), '');
};